/**
 * Compare to values with deep equal
 * @param {Object} options Options
 * @param {String|Number} options.value Current value
 * @param {String|Number} options.comparison Compare value against this with ===
 * @param {String} options.message Error message
 * @param {Function} options.callback async-validator callback
 */
function compare ({ value, comparison, message, callback }) {
  if (value !== comparison) {
    return callback(new Error(message))
  }

  callback()
}

/**
 * Validate file type
 * @param {Object} options Options
 * @param {File} options.value Current value
 * @param {Array<String>} options.accept Accepted MIME types
 * @param {String} options.message Error message
 * @param {Function} options.callback async-validator callback
 */
function fileType ({ value, accept, message, callback }) {
  if (value && !accept.includes(value.type)) {
    return callback(new Error(message))
  }

  callback()
}

/**
 * Validate phone number
 * @param {Object} options Options
 * @param {String} options.value Current value
 * @param {String} options.message Error message
 * @param {Function} options.callback async-validator callback
 */
function phoneNumber ({ value, message, callback }) {
  if (value && /[a-zßäöü]/i.test(value)) {
    return callback(new Error(message))
  }

  callback()
}

/**
 * Execute validation for another field
 * @param {Object} options Options
 * @param {Object} options.form Vue form ref
 * @param {String} options.field Form field prop
 * @param {*} options.fieldValue Form field value
 * @param {Function} options.callback async-validator callback
 */
function validateField ({ form, field, fieldValue, callback }) {
  if (fieldValue) {
    form.validateField(field)
  }

  callback()
}

export default {
  compare,
  fileType,
  phoneNumber,
  validateField
}
